import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import AlertBar from './AlertBar'
import Navbar from './Navbar'
import { StripeCheckoutProvider, useUserContext } from 'context'
import { axiosPlain } from 'api'
import { PendingPayment } from '../Membership/PendingPayment'
import useUpdateCountry from 'hooks/useUpdateCountry'
import {
  retrieveAndClearEvents,
  sign_up_from_query_params
} from 'gtm/pushEvents'
import { multipassRedirect, useAlert } from 'hooks'
import { signout_from_aloyoga } from 'hooks/ssoSignoutHandler'
import { useCookies } from 'react-cookie'
import { clear_braze_user } from 'braze/brazeEvents'

const Header = ({ controls, ...rest }) => {
  const { user } = useUserContext()
  const getGa4Events = user && user?.getGa4Events
  const username = user && user?.username
  const aloLinkedStatus = user?.aloLinkedStatus
  const stripeApiKey = user?.stripeApiKey
  const setAlert = useAlert()
  const [cookie, , clearCookie] = useCookies(['clear_localstorage'])
  const [triggerClear, , removeTriggerClear] = useCookies(['clear_coachmarks'])
  const clearLocal = cookie?.clear_localstorage === 'true'
  const clearCoachmarks = triggerClear?.clear_coachmarks === 'true'

  useUpdateCountry()

  useEffect(() => {
    if (localStorage.getItem('emailUpdated') === 'true') {
      setAlert({
        message:
          'Verified! Use your ALO account to log in to AWC moving forward.'
      })
      localStorage.removeItem('emailUpdated')
    }

    const handleCoachmark = async (str) => {
      let data = str
      try {
        data = JSON.parse(str)
      } catch {
        data = str
      } finally {
        window.dataLayer ||= []
        window.dataLayer.push(data)
        localStorage.removeItem('abandoned_coachmark_data')
      }
    }
    const handleAbandoned = async () => {
      let abandoned_coachmark = null
      try {
        abandoned_coachmark = JSON.parse(
          localStorage.getItem('abandoned_coachmark_data')
        )?.[username]
      } catch {}
      if (abandoned_coachmark) {
        handleCoachmark(abandoned_coachmark)
      }
    }
    handleAbandoned()
    window.addEventListener('locationchange', handleAbandoned)
    return () => document.removeEventListener('locationchange', handleAbandoned)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [username])

  useEffect(() => {
    if (clearCoachmarks) {
      Object.keys(localStorage)
        .filter((key) => key.includes('coachmark'))
        .forEach((key) => {
          localStorage.removeItem(key)
        })
      removeTriggerClear('clear_coachmarks', { path: '/' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearCoachmarks])

  useEffect(() => {
    if (clearLocal) {
      clear_braze_user()
      localStorage.clear()
      clearCookie('clear_localstorage', { path: '/' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clearLocal])

  useEffect(() => {
    const run = () => {
      if (rest?.authTokenState) {
        let data = window.REACT_ENV_VARIABLES || {}
        window.REACT_ENV_VARIABLES = {
          ...data,
          ALO_AUTH_TOKEN_STATE: rest?.authTokenState
        }
      }
      if (Boolean(aloLinkedStatus)) {
        multipassRedirect()
      }
      signout_from_aloyoga()
    }

    if (document.readyState === 'complete') {
      run()
    } else {
      window.addEventListener('load', run)
      return () => window.removeEventListener('load', run)
    }
  }, [aloLinkedStatus, rest])

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('sign_up') === 'true' && user) {
      sign_up_from_query_params(user)
    }
  }, [user])

  useEffect(() => {
    retrieveAndClearEvents()
    if (getGa4Events) {
      axiosPlain
        .get('/users/events')
        .then((res) => {
          const events = res.data?.ga4_events
          if (events && Array.isArray(events)) {
            window.dataLayer = window.dataLayer || []
            window.dataLayer.push(...events)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    }
  }, [getGa4Events])

  return (
    <React.Fragment>
      {controls.alert && <AlertBar />}
      {controls.navbar && (
        <Navbar links={controls.navbarLinks} auth={controls.navbarAuth} />
      )}
      {stripeApiKey && (
        <StripeCheckoutProvider stripeApiKey={stripeApiKey}>
          <PendingPayment />
        </StripeCheckoutProvider>
      )}
    </React.Fragment>
  )
}

Header.defaultProps = {
  controls: {
    alert: true,
    navbar: true,
    navbarLinks: true, // Links, hoverables, search, etc.
    navbarAuth: true
  }
}

Header.propTypes = {
  controls: PropTypes.object
}

export default Header
